import { Fragment } from "react";
// Imported as ProgramTips, as this page keeps its list of Tips in a Tips variable.
import ProgramTips from "./Tips";
import PoolItemWideLoaderLarge from "./PoolItemWideLoaderLarge";
import { useApi } from "../lib/useApi";
import { programKey } from "../lib/program";
import { poolTypeById } from "../poolTypes";

// The line above the Tips: the loader until they arrive, then a panel if there are none.
const tipsStatus = (volume) => {
  if (volume === -1) return <PoolItemWideLoaderLarge />;
  if (volume === 0) return <div className="panel">No tips currently available for this pool.</div>;
  return "";
};

const TipsPage = ({ pool_id }) => {
  // Soccer Scores and Soccer Corners have Tips pages but no tips config, so they render none.
  const renderTipsType = (item) => {
    const poolType = poolTypeById(pool_id);
    return poolType?.tips ? <ProgramTips poolType={poolType} item={item} /> : null;
  };

  let page_name = "";
  switch (pool_id) {
    case 6:
      page_name = "Top Tips - Soccer 6";
      break;
    case 10:
      page_name = "Top Tips - Soccer 10";
      break;
    case 13:
      page_name = "Top Tips - Soccer 13";
      break;
    case 4:
      page_name = "Top Tips - Soccer 4";
      break;
    case 16:
      page_name = "Top Tips - Soccer Any 13 Xtra";
      break;
    case 1:
      page_name = "Top Tips - Soccer 1";
      break;
    case 8:
      page_name = "Top Tips - Soccer 8";
      break;
    case 11:
      page_name = "Top Tips - Mega 10 Jackpot ";
      break;
    default:
      page_name = "Error ";
  }
  const { data } = useApi(`/api/GetTips/${pool_id}`, {
    select: (json) => {
      const temp = [];
      for (const tip of json.value) {
        temp.push(tip);
      }
      return { tips: temp, page_name };
    },
  });
  const Tips = data ? data.tips : [];
  const TipsVolume = data ? data.tips.length : -1;
  const PageName = data ? data.page_name : "";

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <h1>{PageName}</h1>
        {tipsStatus(TipsVolume)}
        {Tips.map((item) => <Fragment key={programKey(item)}>{renderTipsType(item)}</Fragment>)}
      </div>
    </div>
  );
};

export default TipsPage;
